<div class="container-tutorial mx-auto p-5">
    <div class="row">
        <div class="col-12">
            <h1 class="font-weight-bold">
                Tutorial - Activar MFA
            </h1>
        </div>
        <div class="col-12 my-4">
            <span>El MFA (Autenticación Multifactor) añade una capa extra de seguridad a tu cuenta.</span>
            <p class="font-italic">Aunque en este tutorial usamos Google Authenticator y Microsoft Authenticator como ejemplo, también puedes usar otras aplicaciones compatibles como Authy o cualquier app que soporte el estándar TOTP.</p>
        </div>

        <div class="col-12 my-4">
            <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center" (selectedTabChange)="onTabChange($event)">
                <mat-tab label="Google Authenticator"></mat-tab>
                <mat-tab label="Microsoft Authenticator"></mat-tab>
            </mat-tab-group>
        </div>

        <div class="col-12 mt-5">
            <h2 class="font-weight-bold mb-3">
                Paso 1: Instalar {{showGoogle ? 'Google Authenticator' : 'Microsoft Authenticator'}} en tu teléfono
            </h2>
            <ul>
                <li>En Android: abre Google Play Store y busca “{{showGoogle ? 'Google Authenticator' : 'Microsoft Authenticator'}}”.</li>
                <li>En iPhone: abre App Store y busca “{{showGoogle ? 'Google Authenticator' : 'Microsoft Authenticator'}}”.</li>
            </ul>
            <span>Descarga, instala y configura la aplicación.</span>
        </div>
        <div class="col-12 mx-auto mb-3 d-flex justify-content-center">
            <img src="../../../assets/img/instalar-authenticator-min-527x1200.png" *ngIf="showGoogle" alt="Imagen descarga Google Authenticator">
            <img src="../../../assets/img/Microsoft-Authenticator-install.png" *ngIf="!showGoogle" alt="Imagen descarga Microsoft Authenticator">
        </div>
        <div class="col-12 mt-3">
            <h2 class="font-weight-bold mb-3">
                Paso 2: Inicia el proceso de configuración de MFA en tu cuenta
            </h2>
            <ul>
                <li>Ingresa a la web de Informax.</li>
                <li>Abre el menú principal.</li>
                <li>Haz clic en “Configuración MFA”.</li>
            </ul>
        </div>
        <div class="col-12 mx-auto mt-2 mb-3 d-flex justify-content-center">
            <img src="../../../assets/img/menu-mfa.png" alt="Imagen menu informax">
        </div>
        <div class="col-12 mt-3">
            <h2 class="font-weight-bold mb-3">
                Paso 3: Escanea el código QR
            </h2>
            <ul>
                <li>En la pantalla de configuración, verás un código QR y, debajo, una clave secreta (por si no puedes usar el QR).</li>
                <li>Abre {{showGoogle ? 'Google Authenticator' : 'Microsoft Authenticator'}} en tu teléfono.</li>
                <li *ngIf="showGoogle">Pulsa el botón “+” → “Escanear código QR”.</li>
                <li *ngIf="!showGoogle">En la pantalla principal pulsa el símbolo de QR en la parte inferior izquierda o pulsa el botón “+” → “Otra cuenta”.</li>
                <li>Apunta la cámara de tu teléfono al código QR que aparece en tu pantalla.</li>
            </ul>
            <span class="font-italic" *ngIf="showGoogle">Si no puedes escanear el QR, en Google Authenticator selecciona “Ingresar clave manualmente” y escribe la clave secreta que aparece debajo del QR.</span>
            <span class="font-italic" *ngIf="!showGoogle">Si no puedes escanear el QR, en Google Authenticator selecciona “Enter code manually” y escribe la clave secreta que aparece debajo del QR.</span>
            <span class="font-italic" *ngIf="!showGoogle">Si lo ingresas manualmente deberás indicarle un nombre a la cuenta.</span>
        </div>
        <div class="mx-auto mt-2 mb-3 d-flex justify-content-center" [ngClass]="showGoogle ? 'col-sm-12 col-md-6' : 'col-sm-12'">
            <img src="../../../assets/img/qr-mfa.png" alt="Imagen escaneo código QR">
        </div>
        <div class="col-sm-12 col-md-6 mx-auto mt-2 mb-3 d-flex justify-content-center" *ngIf="showGoogle">
            <img src="../../../assets/img/mfa-qr-app.png" alt="Imagen opciones escaneo Google Authenticator">
        </div>
        <div class="col-sm-12 col-md-4 mx-auto mt-2 mb-3 d-flex justify-content-center" *ngIf="!showGoogle">
            <img src="../../../assets/img/MFA-Microsoft-Authenticator-QR.png" class="w-100" alt="Imagen opciones escaneo Microsoft Authenticator">
        </div>
        <div class="col-sm-12 col-md-4 mx-auto mt-2 mb-3 d-flex justify-content-center" *ngIf="!showGoogle">
            <img src="../../../assets/img/select-account-image.png" class="w-100" alt="Imagen opciones cuenta Microsoft Authenticator">
        </div>
        <div class="col-sm-12 col-md-4 mx-auto mt-2 mb-3 d-flex justify-content-center" *ngIf="!showGoogle">
            <img src="../../../assets/img/Microsoft-Authenticator-camera.png" class="w-100" alt="Imagen camara Microsoft Authenticator">
        </div>
        <div class="col-12 mt-3">
            <h2 class="font-weight-bold mb-3">
                Paso 4: Verifica el código
            </h2>
            <ul>
                <li>{{showGoogle ? 'Google Authenticator' : 'Microsoft Authenticator'}} mostrará un código de 6 dígitos que cambia cada 30 segundos.</li>
                <li>Escríbelo en el campo de ingreso de código.</li>
                <li>Haz clic en “Activar verificación en dos pasos”.</li>
            </ul>
        </div>
        <div class="col-12 mx-auto mt-2 mb-3 d-flex justify-content-center">
            <img src="../../../assets/img/mfa-codigo.png" alt="Imagen ingreso codigo informax">
        </div>
        <div class="col-12 mb-3">
            <h2 class="font-weight-bold mb-3">
                Listo, MFA activado
            </h2>
            <ul>
                <li>A partir de ahora:</li>
                <li>Cuando inicies sesión, introduce tu usuario y contraseña.</li>
                <li>Luego abre {{showGoogle ? 'Google Authenticator' : 'Microsoft Authenticator'}}, revisa el código y escríbelo en la pantalla de verificación.</li>
            </ul>
            <span class="font-italic">
                Importante: Si cambias o pierdes el teléfono, deberás solicitar el desbloqueo a soporte y configurar nuevamente tu MFA siguiendo este mismo proceso.
            </span>
        </div>
        <div class="col-sm-12 col-md-6 mx-auto mt-2 mb-3 d-flex justify-content-center">
            <img src="../../../assets/img/inicio-sesion.png" alt="Imagen formulario inicio sesion informax">
        </div>
        <div class="col-sm-12 col-md-6 mx-auto mt-2 mb-3 d-flex justify-content-center">
            <img src="../../../assets/img/inicio-sesion-mfa.png" alt="Imagen confirmar codigo inicio sesion informax">
        </div>
    </div>
</div>